<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      enable-resize-watcher
      fixed
      app
      class="grey darken-4"
    >
      <side-drawer></side-drawer>
    </v-navigation-drawer>
    <v-toolbar
      app
      color="primary"
      class="elevation-1"
    >
      <v-btn icon @click="goBack()">
        <v-icon>keyboard_arrow_left</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-toolbar-title>{{ bannerId ? 'Edit ' + bannerId : 'Add Banner' }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-menu v-if="bannerId" bottom left>
        <v-btn icon slot="activator">
          <v-icon>more_vert</v-icon>
        </v-btn>
        <v-list>
          <v-list-tile @click.stop="openDeleteBannerDialog">
            <v-list-tile-title>Delete</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar>
    <v-content>
      <v-layout row wrap>
        <v-flex
          xs12
          text-xs-center
          layout
          align-content-start
          justify-center
          pa-3
        >
          <v-form ref="form" v-model="frmValid">
            <v-layout row wrap v-if="!bannerId">
              <v-flex xs12 class="text-xs-center text-sm-center text-md-center text-lg-center">
                <img :src="imageUrl" height="150" v-if="imageUrl"/>
                <v-text-field label="Banner Image" @click='pickFile' v-model='imageName'></v-text-field>
                <input
                  type="file"
                  style="display: none"
                  ref="image"
                  accept="image/*"
                  @change="onFilePicked"
                  @click="$refs.image.value = null"
                >
              </v-flex>
            </v-layout>
            <v-layout row wrap v-else>
              <v-flex xs12 class="text-xs-center text-sm-center text-md-center text-lg-center">
                <img :src="imageUrl" height="150" v-if="imageUrl"/>
              </v-flex>
            </v-layout>
            <v-text-field
              v-model="txtProductId"
              label="Link to Product Id"
            ></v-text-field>
            <v-select
              v-model="cboCategory"
              :items="categories"
              item-text="name"
              item-value="categoryId"
              label="Link to Category Id"
            ></v-select>
            <v-text-field
              v-model="txtPath"
              label="Link to Path (eg. products?search=ufi)"
            ></v-text-field>
            <v-text-field
              v-model="txtUrl"
              label="Link to External URL (eg. https://www.ufi-box.com)"
            ></v-text-field>
            <v-autocomplete
              v-model="cboButtonTopPosPercentage"
              :items="percentages"
              label="Button Top Position"
            ></v-autocomplete>
            <v-select
              v-model="cboSequence"
              :items="sequences"
              :rules="[v => !!v || 'Please select order sequence']"
              label="Order Sequence"
              required
            ></v-select>
            <v-btn
              :disabled="!frmValid"
              @click="submit"
            >
              Save
            </v-btn>
          </v-form>
        </v-flex>
      </v-layout>
      <v-dialog
        v-model="dialogDelete"
        max-width="290"
      >
        <v-card>
          <v-card-title class="headline">Confirm to delete this banner?</v-card-title>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="primary"
              flat="flat"
              @click="dialogDelete = false"
            >
              Cancel
            </v-btn>

            <v-btn
              color="primary"
              flat="flat"
              @click="deleteBanner()"
            >
              Delete
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="loading"
        hide-overlay
        persistent
        width="220"
      >
        <loading></loading>
      </v-dialog>
    </v-content>
  </div>
</template>

<style scoped>
form {
  width: 100%;
}
</style>

<script>
import SideDrawer from '@/components/SideDrawer.vue'
import Loading from '@/components/Loading.vue'
import router from '../router'
import axios from 'axios'

export default {
  props: [
    'bannerId'
  ],
  components: {
    SideDrawer,
    Loading
  },
  data: () => ({
    drawer: false,
    loading: false,
    frmAddImageValid: false,
    dialogAddImage: false,
    dialogImage: false,
    imageName: '',
    imageUrl: '',
    imageFile: '',
    frmValid: true,
    txtProductId: '',
    cboCategory: '',
    categories: [
      {
        categoryId: '',
        name: ''
      }
    ],
    txtPath: '',
    txtUrl: '',
    cboButtonTopPosPercentage: null,
    percentages: [],
    cboSequence: null,
    sequences: [1, 2, 3, 4, 5],
    dialogDelete: false
  }),

  mounted () {
    this.init()
    this.openDrawerForDesktop()
    this.getBanner(this.bannerId)
    this.getCategories()
  },

  methods: {
    init: function () {
      for (var i = 0; i <= 100; i++) {
        this.percentages.push(i)
      }
    },
    openDeleteBannerDialog: function () {
      this.dialogDelete = true
    },
    deleteBanner: function () {
      this.loading = true
      axios.delete(process.env.VUE_APP_API_ROOT + '/v1/banner/' + this.bannerId)
        .then(resp => {
          this.loading = false
          console.log(resp.data)
          if (resp.data.status === 'success') {
            router.push('/banner/main/list')
          } else {
            window.alert(resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + this.$route.fullPath)
            } else if (error.response.status === 403) {
              this.showAlert(error)
            }
            this.loading = false
          }
        })
    },
    getBanner: function (bannerId) {
      if (bannerId) {
        this.loading = true
        axios.get(process.env.VUE_APP_API_ROOT + '/v1/banner/' + bannerId)
          .then(resp => {
            this.loading = false
            console.log(resp.data)
            if (resp.data.status === 'success') {
              this.imageUrl = resp.data.data.largeUrl
              this.txtProductId = resp.data.data.linkToProductId
              this.cboCategory = resp.data.data.linkToCategoryId
              this.txtPath = resp.data.data.linkToPath
              this.txtUrl = resp.data.data.linkToUrl
              this.cboButtonTopPosPercentage = resp.data.data.buttonTopPosPercentage
              this.cboSequence = resp.data.data.orderSequence
            } else {
              console.log('unable to load banner details: ' + resp.data.message)
            }
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + this.$route.fullPath)
              } else if (error.response.status === 403) {
                this.showAlert(error)
              }
              this.loading = false
            }
          })
      }
    },
    getCategories: function () {
      axios.get(process.env.VUE_APP_API_ROOT + '/v1/categories')
        .then(resp => {
          console.log(resp.data)
          if (resp.data.status === 'success') {
            var categories = []
            var result = this.generateCategoryListRecursive(resp.data.data, categories, 0)
            this.categories = this.categories.concat(result)
          } else {
            console.log('unable to load categories: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + this.$route.fullPath)
            } else if (error.response.status === 403) {
              this.showAlert(error)
            }
          }
        })
    },
    generateCategoryListRecursive: function (inputCategories, output, level) {
      var strPad = ''
      for (var j = 0; j < level; j++) {
        strPad = strPad + '----'
      }
      for (var i = 0; i < inputCategories.length; i++) {
        inputCategories[i].level = level
        inputCategories[i].name = strPad + ' ' + inputCategories[i].name
        output.push(inputCategories[i])
        if (inputCategories[i].childs.length > 0) {
          output = this.generateCategoryListRecursive(inputCategories[i].childs, output, level + 1)
        }
      }
      return output
    },
    resetImageForm () {
      this.imageName = ''
      this.imageUrl = ''
      this.imageFile = ''
    },
    pickFile () {
      this.$refs.image.click()
    },
    onFilePicked (e) {
      this.resetImageForm()
      const files = e.target.files
      if (files[0] !== undefined) {
        this.imageName = files[0].name
        if (this.imageName.lastIndexOf('.') <= 0) {
          return
        }
        const fr = new FileReader()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          this.imageUrl = fr.result
          this.imageFile = files[0] // this is an image file that can be sent to server...
        })
      }
    },
    submit () {
      if (this.$refs.form.validate()) {
        if (this.bannerId) {
          this.loading = true
          axios.put(process.env.VUE_APP_API_ROOT + '/v1/banner/' + this.bannerId, {
            linkToProductId: this.txtProductId,
            linkToCategoryId: this.cboCategory,
            linkToPath: this.txtPath,
            linkToUrl: this.txtUrl,
            buttonTopPosPercentage: this.cboButtonTopPosPercentage,
            orderSequence: this.cboSequence
          }, {
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(resp => {
              this.loading = false
              console.log(resp.data)
              if (resp.data.status === 'success') {
                router.push('/banner/main/list')
              } else {
                window.alert(resp.data.message)
              }
            })
            .catch(function (error) {
              if (error.response) {
                console.log(error.response.status)
                if (error.response.status === 401) {
                  router.push('/login?next=' + this.$route.fullPath)
                } else if (error.response.status === 403) {
                  this.showAlert(error)
                }
                this.loading = false
              }
            })
        } else {
          var formData = new FormData()
          console.log(this.imageFile)
          formData.append('linkToProductId', this.txtProductId)
          formData.append('linkToCategoryId', this.cboCategory)
          if (this.txtPath !== '') {
            formData.append('linkToPath', this.txtPath)
          }
          if (this.txtUrl !== '') {
            formData.append('linkToUrl', this.txtUrl)
          }
          formData.append('orderSequence', this.cboSequence)
          formData.append('buttonTopPosPercentage', this.cboButtonTopPosPercentage)
          formData.append('imageFile', this.imageFile, this.imageName)
          this.loading = true
          axios.post(process.env.VUE_APP_API_ROOT + '/v1/banner', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
            .then(resp => {
              this.loading = false
              console.log(resp.data)
              if (resp.data.status === 'success') {
                router.push('/banner/main/list')
              } else {
                window.alert(resp.data.message)
              }
            })
            .catch(function (error) {
              if (error.response) {
                console.log(error.response.status)
                if (error.response.status === 401) {
                  router.push('/login?next=' + this.$route.fullPath)
                } else if (error.response.status === 403) {
                  this.showAlert(error)
                }
                this.loading = false
              }
            })
        }
      }
    }
  }
}
</script>
